import React from "react";

const personalInfoContent = [
  { meta: "first name", metaInfo: "Sandeep" },
  { meta: "last name", metaInfo: "Bansod" },
  { meta: "Nationality", metaInfo: "Indian" },
  { meta: "Address", metaInfo: "India" },
  { meta: "phone", metaInfo: "+91-7757932477" },
  { meta: "Email", metaInfo: "me@sandeepbansod.com" },
  { meta: "Email", metaInfo: "sndpbansod5@gmail.com" },
  { meta: "Language", metaInfo: "English, Hindi, Marathi" },
];

const PersonalInfo = () => {
  return (
    <ul className="about-list list-unstyled open-sans-font">
      {personalInfoContent.map((val, i) => (
        <li key={i}>
          <span className="title">{val.meta}: </span>
          <span className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block">
            {val.metaInfo}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default PersonalInfo;
